export const CUSTOM_PG_EVENTS = ['game_opened', 'ping', 'navigation', 'portal_session_end'] as const
export const SURVEY_PG_EVENTS = ['survey_game_completed'] as const

export const DEFAULT_CLIDS = {
    direct: 'direct',
    directTest: 'direct-test',
    unknown: 'unknown',
}

export const MANIFEST_META_KEY = 'pwa-manifest'
export const DEFAULT_MAIN_PAGE_SIZE = 16
// divisible by 2, 3, 4, 6 to make a nice grid with big cards
export const DEFAULT_CATEGORY_PAGE_SIZE = 45
export const DEFAULT_RECOMMENDATION_SIZE = 16
export const BACKEND_FLAGS_QUERY = 'backend_flags'
export const CLOUDFLARE_CUSTOMER_URL = 'https://customer-8wsds98g05tbeoot.cloudflarestream.com/'
